import httpClient from "./auth-http-client";

const getChallenges = async () => {
    try {
        const response = await httpClient.get(`/challenges`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
};

const startGame = async () => {
    try {
        const response = await httpClient.get(`/challenges/start`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
};

const submitScavengerHunt = async (data: any) => {
    try {
        const response = await httpClient.post(`/challenges/scavenger`, data);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
}

const submitChallenge = async (data: any) => {
    try {
        const response = await httpClient.post(`/challenges/challenge`, data);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
}

const generateDailyMissions = async () => {
    try {
        const response = await httpClient.get(`/challenges/generate`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
}

const regenerateChallenge = async (challengeId: any) => {
    try {
        const response = await httpClient.get(`/challenges/regenerate/${challengeId}`);
        if (response.status === 200) {
            return response.data
        }
        return {}
    } catch (error) {
        console.error("Error:", error);
    }
}

export {
    getChallenges,
    startGame,
    submitScavengerHunt,
    submitChallenge,
    generateDailyMissions,
    regenerateChallenge
}